import usdt from "../images/tether.png";
import rmn from "../images/RMN-token-logo.png";
import maallogo from "./../images/maal_icon.png"

export const multisigwallet = "0xC57E89Dda471f142eA3bB140eb7E7dd4f81039eC"
export const multisigwallet2 = "0xc298aCEDe98982674E199da154Eaea649a010E18"

export const defaultMaalReserveUSDT = 80000000;
export const defaultCirculationSupply = 150000000;

export const bscapidetails = {
    BSC_API_URL:"https://api.bscscan.com/api", // BSC API for transactions
    BSC_API_KEY:"" // Add your BSC API key if needed
}

export const euroReserved = "https://por-api.infinnity.capital/don-4/euro-cash-reserves"

// Legacy constants kept for backward compatibility
export const TokenToAddress = []
export const coinGeckoIDbyName = {}

export const defaultchainid = "56"

// Reserved tokens for balance calculations
export const ReservedToken = {
    // "BNB":{
    //     isNative:true,
    //     address:"0x0000000000000000000000000000000000000000",
    //     tokenName:"BNB",
    //     coingeckoid:'binancecoin'
    // },
    "MAAL":{
        isNative:false,
        address:"0xC57E89Dda471f142eA3bB140eb7E7dd4f81039eC",
        tokenName:"MAAL",
        coingeckoid:'maal-chain'
    }
}

// BSC Mainnet Tokens
export const tokenAddress = {
    ICEUR:"0x07571b93e07E1b198661D11041a9E48B2f0b073d", 
    ICUSD:"0xe05D4c8A972Ee90478861F2c87296bB190adB0b8", 
}

export const tokenfromChain = {
    "56":["ICEUR","ICUSD"],
}

// now this will only work for mainnets
export const addressFromSymbol = {
    "ICEUR":"0x07571b93e07E1b198661D11041a9E48B2f0b073d", 
    "ICUSD":"0xe05D4c8A972Ee90478861F2c87296bB190adB0b8", 
}

export const tokenLogofromChain = {
    "ICEUR":rmn,
    "ICUSD":rmn,
    "USDT":usdt,
}

export const ChainLogofromChain = {
    "56":"https://assets.coingecko.com/coins/images/825/standard/bnb-icon2_2x.png?1696501970",
}

export const idToExplore = {
    "56":"https://bscscan.com",
}

export const idTorpc = {
    "56":"https://bsc-rpc.publicnode.com",
    "7862":"https://node1-mainnet-new.maalscan.io",
}

export const idToSymbol = {
    "56":"BNB",
}

export const NetworkFromChainId = {
    "56":"Binance Smart Chain",
}

export const netowrkIDHEX = {
    "Binance Smart Chain":"0x38",
}

export const idFromName = {
    "Binance Smart Chain":"56",
}
